<div class="alert alert-danger"
     role="alert"
     *ngIf="errors.length > 0">
  <ul>
    <li *ngFor="let error of errors">{{ error }}</li>
  </ul>
</div>